import { Injectable } from '@angular/core';
import { AuthenticationService, PasswordChange, PasswordReset } from "authentication";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ElaadAuthenticationServiceService implements AuthenticationService {
  changePasswordRequest(passwordChange: PasswordChange): Observable<void> {
    return of();
  }

  resetPassword(passwordReset: PasswordReset): Observable<void> {
    return of();
  }

  resetPasswordRequest(emailAddress: string): Observable<void> {
    return of();
  }

  setPassword(passwordReset: PasswordReset): Observable<void> {
    return of();
  }

  setPasswordRequest(emailAddress: string): Observable<void> {
    return of();
  }

}
